import { useConnection } from "../api/context";
import { t } from "../i18n";

/** Reads retry by themselves; this says so, so the screen never freezes silently. */
export function ConnectionBanner() {
  const connection = useConnection();
  if (connection.status !== "retrying") return null;
  return (
    <div className="banner" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span>{t("connection.retrying", { attempt: connection.attempt, max: connection.maxAttempts })}</span>
    </div>
  );
}
